if (!customElements.get('delivery-information')) {
  class DeliveryInformation extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.select = this.querySelector('[data-delivery-placement]');
      this.other = this.querySelector('[data-delivery-other]');
      this.otherWrapper = this.querySelector('[data-delivery-other-wrapper]');
      this.noteInput = this.querySelector('[data-delivery-note]');
      this.customerNoteInput = this.querySelector('[data-customer-note]');
      this.cartNote = document.getElementById('Cart-note');

      if (!this.form || !this.select) return;

      if (this.cartNote) {
        this.cartNote.removeAttribute('name');
        this.cartNote.dataset.deliveryCustomerNote = '';
        this.cartNote.value = this.customerNoteInput.value;
      }

      this.handlePlacementChange = this.handlePlacementChange.bind(this);
      this.handleOtherInput = debounce(this.handleOtherInput.bind(this), ON_CHANGE_DEBOUNCE_TIMER);
      this.handleSubmit = this.handleSubmit.bind(this);

      this.select.addEventListener('change', this.handlePlacementChange);
      this.other?.addEventListener('input', this.handleOtherInput);
      this.form.addEventListener('submit', this.handleSubmit);

      this.updatePlacementFields();
      this.syncHiddenNote();
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.handlePlacementChange);
      this.other?.removeEventListener('input', this.handleOtherInput);
      this.form?.removeEventListener('submit', this.handleSubmit);

      if (this.cartNote?.dataset.deliveryCustomerNote !== undefined) {
        this.cartNote.setAttribute('name', 'note');
        delete this.cartNote.dataset.deliveryCustomerNote;
      }
    }

    get selectedType() {
      return this.select.selectedOptions[0]?.dataset.type;
    }

    get customerNote() {
      return this.cartNote?.value ?? this.customerNoteInput?.value ?? '';
    }

    buildNote(customerNote = this.customerNote) {
      let placement = this.select.value;
      if (this.selectedType === 'option_6') placement = this.other?.value.trim() || '';

      return [placement, customerNote.trim()].filter(Boolean).join(' | ');
    }

    syncHiddenNote(customerNote = this.customerNote) {
      if (this.noteInput) this.noteInput.value = this.buildNote(customerNote);
    }

    updatePlacementFields() {
      const showOther = this.selectedType === 'option_6';

      this.otherWrapper?.classList.toggle('hidden', !showOther);
      if (this.other) this.other.required = showOther;
      this.select.setCustomValidity('');
      this.other?.setCustomValidity('');
    }

    handlePlacementChange() {
      this.updatePlacementFields();
      this.syncHiddenNote();
      this.saveCartState();
    }

    handleOtherInput() {
      this.other.setCustomValidity('');
      this.syncHiddenNote();
      this.saveCartState();
    }

    handleSubmit(event) {
      if (!this.select.value) {
        event.preventDefault();
        this.select.setCustomValidity(this.dataset.selectError);
        this.select.reportValidity();
        return;
      }

      if (this.selectedType === 'option_6' && !this.other.value.trim()) {
        event.preventDefault();
        this.other.setCustomValidity(this.dataset.otherError);
        this.other.reportValidity();
        return;
      }

      this.syncHiddenNote();
    }

    saveCartState() {
      const body = { note: this.buildNote() };

      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: JSON.stringify(body) }).catch((error) => {
        console.warn(error);
      });
    }
  }

  customElements.define('delivery-information', DeliveryInformation);
}
